<template>
  <div :class="isMobileNews ? 'mainWrap' : 'mainWrapPhone'">
    <div class="mainBar" :style="{
      backgroundImage: 'url(' + (winW > 1920 ? bannerBg2x : bannerBg) + ')',
    }">

      <headerWX :isMobileNews="isMobileNews"></headerWX>
      <router-view></router-view>
      <footerWX :class="isMobileNews ? '' : 'footerWX'"></footerWX>
      <div class="suspensionWrap" v-if="suspensionShow">
        <div class="suspension">
          <img class="closed" @click="suspensionShow = false" :src="require('@/assets/imgs/public/close.png')" alt="" />
          <img class="pic" :src="require('@/assets/imgs/public/suspension.png')" alt="" />
        </div>
      </div>
      <div class="DoubleEleven" v-if="isDoubleEleven">
        <img class="btn" @click="openDoubleElevenMask" src="@/assets/imgs/DoubleEleven/homeButton.png" alt="">
        <img class="closed" @click="isDoubleEleven = false" :src="require('@/assets/imgs/public/close.png')" alt="" />

      </div>


      <!-- H5遮罩层 活动 -->
      <div id="mask" ref="m" v-if="mask.maskShow" v-cloak>
        <div class="mask_img" ref="maskimg" v-for="(item, index) in close" :key="index" v-show="item.type">
          <a class="mask_img_a_two" :href="item.links" target="_blank"></a>
          <!-- <button
            :class="item.id == 1 ? 'mask_one' : 'mask_two'"
            @click="maskAB(item.id)"
          >
            X
          </button> -->
          <button class="mask_one" @click="maskAB(item, index)" v-if="yanchi">
            <img src="@/assets/closeBtn.png" alt="">
          </button>
          <img :src="item.url" />
          <div class="input_check_one" v-if="yanchi">
            <input type="checkbox" v-model="item.checkFlag" /> 今日不再提示
          </div>

          <!-- <input
            v-if="item.id == 2"
            class="input_check_two"
            type="checkbox"
            v-model="mask.checkFlagtwo"
          /> -->
        </div>
      </div>

      <!-- 活动排行榜 -->
      <div id="mask" ref="m" v-if="isDoubleElevenMaskShow" v-cloak>
        <div class="rankingList_body">
          <img class="closed" @click="isDoubleElevenMaskShow = false" :src="require('@/assets/imgs/public/close.png')"
            alt="" />
          <img class="bg" src="@/assets/imgs/DoubleEleven/homeBg.png" alt="">
          <div class="item">
            <div class="item_list" v-for="value in DoubleEleven_data" :key="value.rank">
              <div class="item_list_public ranking">
                <img src="" alt="">
                <p v-if="![1, 2, 3].includes(value.rank)">
                  {{ value.rank }}
                </p>
                <img v-else-if="value.rank == 1" src="@/assets/imgs/public/0.png" alt="">
                <img v-else-if="value.rank == 2" src="@/assets/imgs/public/1.png" alt="">
                <img v-else-if="value.rank == 3" src="@/assets/imgs/public/2.png" alt="">
              </div>
              <div class="item_list_public usernick">{{ value.usernick }}</div>
              <div class="item_list_public money">{{ value.money }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerWX from "@/components/Header";
import footerWX from "@/components/Footer";
import axios from "axios";
export default {
  name: "index",
  components: {
    headerWX,
    footerWX,
  },
  data() {
    return {
      bannerBg: require("@/assets/imgs/public/bannerBg.png"),
      bannerBg2x: require("@/assets/imgs/public/bannerBg2x.png"),
      // bannerBg4: require("@/assets/imgs/public/bannerBg4.png"),
      winW: 1200,
      suspensionShow: true,
      isMobileNews: true, //是否手机 只有新闻页
      yanchi: false,
      mask: {
        maskimg: [],
        maskShow: false,
        maskone: true,
        masktuo: false,
        checkFlagone: false,
        checkFlagtwo: false,
      },
      LCnoe: {
        type: false,
        tiem: "",
      },
      LCwto: {
        type: false,
        tiem: "",
      },
      close: [],
      DoubleEleven_data: [],//活动数据
      isDoubleEleven: false, //是否双十一
      isDoubleElevenMaskShow: false //是否打开活动排行弹窗
    };
  },
  created() {
    this.getActivities();
  },
  mounted() {
    if (this.isMobile()) {
      this.suspensionShow = false
    }

  },

  methods: {

    isMobile() {
      // 1. 先通过屏幕宽度初步判断（手机端通常屏幕宽度 <= 768px）
      const isSmallScreen = window.innerWidth <= 768;

      // 2. 再通过 UA 判断是否为移动设备（排除平板等大屏设备）
      const userAgent = navigator.userAgent.toLowerCase();
      // 移动设备关键词（包含常见手机系统，排除平板特定标识）
      const mobileKeywords = [
        'android', 'iphone', 'ipod', 'windows phone',
        'mobile', 'symbian', 'blackberry', 'opera mini'
      ];
      // 平板设备关键词（用于排除）
      const tabletKeywords = ['ipad', 'tablet', 'playbook', 'silk'];
      const isMobileUA = mobileKeywords.some(key => userAgent.includes(key))
        && !tabletKeywords.some(key => userAgent.includes(key));

      // 3. 综合判断：屏幕宽度达标 且 UA 识别为移动设备
      return isSmallScreen && isMobileUA;
    },


    winResize() {
      this.winW = document.documentElement.clientWidth;
    },
    async getActivities() {

      const that = this;
      // console.log(Date.parse(new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)), 'll', Date.parse(new Date()));
      // this.LCnoe = JSON.parse(localStorage.getItem("checkFlagone"))
      //   ? JSON.parse(localStorage.getItem("checkFlagone"))
      //   : { type: "", tiem: "" };
      // this.LCwto = JSON.parse(localStorage.getItem("checkFlagtwo"))
      //   ? JSON.parse(localStorage.getItem("checkFlagtwo"))
      //   : { type: "", tiem: "" };
      // console.log(this.LCnoe.type && this.LCwto.type ||  this.LCnoe.tiem ==''?false: Date.parse(new Date()) > this.LCnoe.tiem || this.LCwto.tiem ==''?false: Date.parse(new Date()) > this.LCwto.tiem )
      if (this.$router.history.current.fullPath == "/") {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // if (
        //   this.LCnoe.tiem == "" ? false : Date.parse(new Date()) > this.LCnoe.tiem
        // ) {
        //   this.LCnoe.type = false;
        // }
        // if (
        //   this.LCwto.tiem == "" ? false : Date.parse(new Date()) > this.LCwto.tiem
        // ) {
        //   this.LCwto.type = false;
        // }
        // if (this.LCnoe.type && this.LCwto.type) {
        //   this.mask.maskShow = false;
        // } else {
        //   if (this.LCnoe.type) {
        //     this.mask.maskone = false;
        //     this.mask.masktuo = true;
        //   }
        //   if (this.LCwto.type == true) {
        //     this.mask.maskone = true;
        //     this.mask.masktuo = false;
        //   }

        axios({
          method: "get",
          url: "/common/getWebImgList",
          xhrFields: {
            withCredentials: true,
          },
        })
          .then((res) => {
            // this.isDoubleEleven = res.data.data.rankStatus //是否开启十一排行按钮
            // this.mask.maskimg = res.data.data.list;
            // console.log(this.mask.maskimg, res.data, 'list');
            for (let index = 0; index < res.data.data.list.length; index++) {
              if (localStorage.getItem(`checkFlag${index + 1}`)) {
                const outTime = JSON.parse(localStorage.getItem(`checkFlag${index + 1}`)).tiem
                const nowTime = Date.parse(new Date())
                if (nowTime > outTime) {
                  that.close.push({
                    type: false,
                    id: index + 1,
                    url: res.data.data.list[index].imgUrl,
                    links: res.data.data.list[index].links,
                    checkFlag: false
                  })

                }
                // console.log(Date.parse(new Date()),JSON.parse(localStorage.getItem(`checkFlag${index + 1}`)).tiem , 'local');
              } else {
                that.close.push({
                  type: false,
                  id: index + 1,
                  url: res.data.data.list[index].imgUrl,
                  links: res.data.data.list[index].links,
                  checkFlag: false
                })
              }


            }
            // 是否启用遮罩层
            if (that.close.length == 0) {
              console.log("遮罩层未启用");
              this.mask.maskShow = false;
              loading.close();

              return
            } else {
              that.mask.maskShow = true;

              this.$nextTick(function () {
                let timer = setInterval(() => {
                  if (that.$refs.maskimg[0].clientWidth > 0) {
                    loading.close();
                    that.yanchi = true;
                    clearInterval(timer)
                  }
                })
              })
              that.close[0].type = true

            }

          })
          .catch((err) => {
            console.log(err);
          });
        // }
      } else {
        console.log('不是首页');
        this.mask.maskShow = false;
      }

    },
    qiyong() {
      const that = this;

    },
    maskAB(item, index) {
      // this.maskShow = false
      // console.log(this.close, 'type');
      if (item.checkFlag == true) {
        localStorage.setItem(
          `checkFlag${item.id}`,
          JSON.stringify({
            id: item.id,
            tiem: Date.parse(
              new Date(
                new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
              )
            ),
          })
        );
        // this.close[item.id].type = false
      }


      if (item.id == this.close[this.close.length - 1].id) {
        this.mask.maskShow = false;

        return
      } else {
        // console.log(this.close, 'type');
        this.close[index + 1].type = true;
        item.type = !item.type

      }




    },

    //打开活动弹窗
    async openDoubleElevenMask() {
      await axios({
        url: '/rank/getActRechargeRank',
        method: "post",
        data: {
          activityName: "shopping",
          platForm: "web",
          userId: 0
        }
      }).then(({ data }) => {
        if (data.state = 200) {
          this.DoubleEleven_data = data.data.rankInfoList
        } else {
          this.$message.error(data.message)
        }
      })
        .catch(() => {
          this.$message.error(data.message)

        })

      this.isDoubleElevenMaskShow = true
    }
  },
  watch: {
    // 只监听特定路由参数（如 id）
    '$route.meta.isMobile': {
      handler(newVal, oldVal) {
        if (this.isMobile() && newVal == true) {
          this.isMobileNews = false
        } else {
          this.isMobileNews = true
        }
        sessionStorage.setItem('isMobile', this.isMobile())
      },
      immediate: true // 初始化时立即执行一次
    }
  },
};
</script>

<style lang="less" scoped>
.mainWrap {
  min-width: 1200px;
  min-height: 100vh;
  background: linear-gradient(180deg, #89c7e4 0%, #89c7e4 100%);
  // background: #58182B;
  // background-image: url('../../assets/imgs/public/bannerBg4.png');

  .mainBar {
    color: #333333;
    background-position: top center;
    background-repeat: no-repeat;
    min-height: 100vh;

    .suspensionWrap {
      position: fixed;
      right: 10px;
      top: 60%;
      z-index: 10;

      .suspension {
        position: relative;
        z-index: 0;
      }

      .closed {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        width: 50px;
        cursor: pointer;
      }

      .pic {
        width: 300px;
      }
    }

    .DoubleEleven {
      position: fixed;
      right: 50px;
      top: 40%;
      z-index: 10;

      .btn {
        height: 30vh;
        max-height: 20vh;
        cursor: pointer;
      }

      .closed {
        position: absolute;
        right: -30%;
        top: -20%;
        z-index: 1;
        height: 20vh;
        max-height: 10vh;
        cursor: pointer;
      }
    }

    [v-cloak] {
      display: none !important
    }

    #mask {
      width: 100vw;
      height: 100vh;
      // opacity: 0.6;
      background-color: rgba(0, 0, 0, 0.8);
      bottom: 0;
      left: 0;
      position: fixed;
      z-index: 999;

      .mask_img {
        opacity: 1;
        width: auto;
        height: auto;
        z-index: 9999;
        position: fixed;
        // position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        img {
          width: 100%;
          height: 100%;
        }

        .mask_one {
          width: 44px;
          height: 35px;
          // font-size: 45px;
          background-color: #ff000000;
          border: none;
          color: #fff;
          z-index: 9999;
          position: absolute;
          // font-weight: 900;
          top: -30px;
          right: -38px;
          // opacity: 0;
        }

        .mask_two {
          width: 50px;
          height: 50px;
          background-color: red;
          z-index: 9999;
          position: absolute;
          top: 80px;
          right: 3px;
          // opacity: 0;
        }

        .input_check_one {
          width: 25%;
          height: 20px;
          z-index: 9999;
          position: absolute;
          // bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 14px;
          color: #fff;
        }

        .input_check_two {
          width: 20px;
          height: 20px;
          z-index: 9999;
          position: absolute;
          bottom: 7px;
          left: 40%;
        }

        .mask_img_a_one {
          width: 75rem;
          height: 38rem;
          z-index: 9999;
          position: fixed;
          top: 57%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .mask_img_a_two {
          width: 90%;
          height: 80%;
          z-index: 9999;
          position: fixed;
          top: 51%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        // right: 500px;
      }

      .rankingList_body {
        opacity: 1;
        width: auto;
        height: auto;
        z-index: 9999;
        position: fixed;
        // position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .bg {
          width: 100%;
          height: 100%;
        }

        .closed {
          position: absolute;
          top: 22%;
          right: 2%;
          width: 10%;
          cursor: pointer;
        }

        .item {
          position: absolute;
          top: 38.5%;
          left: 50%;
          transform: translateX(-50%);
          width: 92%;
          height: 58%;
          display: flex;
          flex-direction: column;

          .item_list {
            height: 10%;
            display: flex;
            align-items: center;

            .item_list_public {
              flex: 1;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 20px;
              color: #ffffff;
              text-shadow: 1px 1px 0 red, -1px -1px 0 red, 1px -1px 0 red, -1px 1px 0 red;
            }

            .ranking {}

            .usernick {}

            .money {}
          }
        }
      }
    }
  }
}

.mainWrapPhone {
  width: 100%;

  .footerWX {
    min-width: 200px;
  }
}
</style>
